import type { ProductLogoMediumProps } from '../types';

/**
 * 中サイズのOrganizationロゴアイコン
 */
export function ProductLogoMediumOrganization({
  size = 40,
  ...props
}: ProductLogoMediumProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 40 40"
      fill="none"
      {...props}
    >
      <rect width="40" height="40" rx="5.88235" fill="#1A2142" />
      <path
        d="M12.2533 30.3975C12.2533 31.5688 11.3038 32.5183 10.1325 32.5183C8.96122 32.5183 8.01172 31.5688 8.01172 30.3975C8.01172 29.2263 8.96122 28.2768 10.1325 28.2768C11.3038 28.2768 12.2533 29.2263 12.2533 30.3975Z"
        fill="#57D7D9"
      />
      <path
        d="M22.1502 30.3975C22.1502 31.5688 21.2007 32.5183 20.0294 32.5183C18.8581 32.5183 17.9086 31.5688 17.9086 30.3975C17.9086 29.2263 18.8581 28.2768 20.0294 28.2768C21.2007 28.2768 22.1502 29.2263 22.1502 30.3975Z"
        fill="#57D7D9"
      />
      <path
        d="M32.0471 30.3975C32.0471 31.5688 31.0976 32.5183 29.9263 32.5183C28.755 32.5183 27.8055 31.5688 27.8055 30.3975C27.8055 29.2263 28.755 28.2768 29.9263 28.2768C31.0976 28.2768 32.0471 29.2263 32.0471 30.3975Z"
        fill="#57D7D9"
      />
      <path
        d="M9.18992 22.6214C9.18992 22.231 9.50642 21.9145 9.89684 21.9145H10.6038V26.156C10.6038 26.5464 10.2873 26.8629 9.89684 26.8629C9.50642 26.8629 9.18992 26.5464 9.18992 26.156V22.6214Z"
        fill="#FCFCFD"
      />
      <path
        d="M28.9837 21.9145H29.6907C30.0811 21.9145 30.3976 22.231 30.3976 22.6214V26.156C30.3976 26.5464 30.0811 26.8629 29.6907 26.8629C29.3002 26.8629 28.9837 26.5464 28.9837 26.156V21.9145Z"
        fill="#FCFCFD"
      />
      <path
        d="M28.9837 21.9145V23.3283L10.6038 23.3283V21.9145H28.9837Z"
        fill="#FCFCFD"
      />
      <path
        d="M19.3225 19.0868C19.3225 18.6964 19.639 18.3799 20.0294 18.3799C20.4198 18.3799 20.7363 18.6964 20.7363 19.0868V26.156C20.7363 26.5464 20.4198 26.8629 20.0294 26.8629C19.639 26.8629 19.3225 26.5464 19.3225 26.156V19.0868Z"
        fill="#FCFCFD"
      />
      <path
        d="M14.1384 15.5522C14.1384 13.9905 15.4044 12.7245 16.9661 12.7245H22.6214C24.1831 12.7245 25.4491 13.9905 25.4491 15.5522V16.4947C25.4491 16.755 25.2381 16.966 24.9778 16.966H14.6097C14.3494 16.966 14.1384 16.755 14.1384 16.4947V15.5522Z"
        fill="#57D7D9"
      />
      <path
        d="M22.8571 8.48296C22.8571 10.0447 21.5911 11.3106 20.0294 11.3106C18.4677 11.3106 17.2017 10.0447 17.2017 8.48296C17.2017 6.92127 18.4677 5.65527 20.0294 5.65527C21.5911 5.65527 22.8571 6.92127 22.8571 8.48296Z"
        fill="#57D7D9"
      />
    </svg>
  );
}
